import { render } from "./product-addons.vue?vue&type=template&id=4ebe4ea6"
import script from "./product-addons.vue?vue&type=script&lang=js"
export * from "./product-addons.vue?vue&type=script&lang=js"

import "./product-addons.vue?vue&type=style&index=0&id=4ebe4ea6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__